import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-new',
  templateUrl: './login-new.component.html',
  styleUrls: ['./login-new.component.scss']
})
export class LoginNewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
